import React, { useEffect, useRef, useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import "./header.css";
import QuoteModal from "../../Contactus-section/GetAQuote/QuoteModal";


function Header() {
  const cardRef = useRef(null);
  const heroRef = useRef(null);

  const particlesInit = async (main) => {
    await loadFull(main);
  };
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    const card = cardRef.current;
    const hero = heroRef.current;

    let mouseX = 0;
    let mouseY = 0;
    let tiltX = 0;
    let tiltY = 0;

    const handleMouseMove = (e) => {
      const rect = card.getBoundingClientRect();

      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      const dx = (e.clientX - cx) / (rect.width / 2);
      const dy = (e.clientY - cy) / (rect.height / 2);

      mouseX = dy * 6;
      mouseY = -dx * 6;
    };

    const animateTilt = () => {
      tiltX += (mouseX - tiltX) * 0.1;
      tiltY += (mouseY - tiltY) * 0.1;

      if (card) {
        card.style.transform = `
          perspective(900px)
          rotateX(${tiltX}deg)
          rotateY(${tiltY}deg)
          scale(1.03)
        `;
      }

      requestAnimationFrame(animateTilt);
    };

    animateTilt();

    hero.addEventListener("mousemove", handleMouseMove);

    hero.addEventListener("mouseleave", () => {
      mouseX = 0;
      mouseY = 0;
    });

    return () => {
      hero.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <section className="header_container" ref={heroRef}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: {
            enable: false,
          },

          particles: {
            number: {
              value: 120,
              density: {
                enable: true,
                value_area: 800,
              },
            },

            color: {
              value: "#ffffff",
            },

            opacity: {
              value: 0.3,
              random: true,
            },

            size: {
              value: 4,
              random: true,
              anim: {
                enable: true,
                speed: 2,
                size_min: 0.3,
              },
            },

            move: {
              enable: true,
              speed: 1.5,
              direction: "bottom",
              out_mode: "out",
            },
          },

          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "bubble",
              },
            },

            modes: {
              bubble: {
                distance: 200,
                size: 6,
                duration: 0.3,
                opacity: 1,
              },
            },
          },

          retina_detect: true,
        }}
      />

      <div className="hero">
        <div className="hero-body">

          {/* LEFT CARD */}
          <div className="card-glass" ref={cardRef}>
            
            <div className="card-title">Neutrosys HRMS</div>

            <div className="card-sub">
              All-in-one HR management platform — built for modern,
              growing businesses. Automate onboarding, manage
              timesheets, track expenses, and empower your team.
            </div>

            <div className="feature-chips">
              <span className="chip">Onboarding</span>
              <span className="chip">Job Management</span>
              <span className="chip">Timesheets</span>
              <span className="chip">Expense Tracking</span>
              <span className="chip">Self Service</span>
              <span className="chip">Leave Management</span>
              <span className="chip">Analytics</span>
            </div>

            <div className="cta-row">
              <a
                className="cta-white"
                href="https://hr.neutrosys.net/"
                target="_blank"
                rel="noreferrer"
              >
                Explore HRMS
              </a>

              <button className="cta-ghost"
               onClick={() => setOpenModal(true)}>
                Request Demo
              </button>

              <QuoteModal
                      show={openModal}
                      handleClose={() => setOpenModal(false)}
                    />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="header_content">
            <h1 className="header-heading">
              Connecting Top Talent with Leading Companies.
            </h1>

            <p className="header-paragraph">
              We provide IT staffing and software development services
              to businesses, helping them achieve their technology
              goals with the right people and solutions.
            </p>

            <div className="header_btn_container">
              <a
                href="./careers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="header_btn blue_background">
                  View all jobs
                </button>
              </a>

              <a
                href="./employers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="header_btn blue_border">
                  Request Resources
                </button>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Header;